import Swiper, { Navigation, Pagination, Scrollbar, EffectFade, Autoplay } from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay]);

//
// Initialization for Swiper library - https://idangero.us/swiper
//

// Default Swiper options
const defaultSwiperOptions = {
  direction: 'horizontal',
  spaceBetween: 32, // equal to .swiper-container padding so arrows can fit
  initialSlide: 0,
  slidesPerView: 1,
  speed: 750,
  observer: true,
  observeParents: true,
  centeredSlidesBound: true,
  centerInsufficientSlides: true,
  watchOverflow: true,
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  slideVisibleClass: 'swiper-slide-visible',
  slidesPerColumnFill: 'row',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  a11y: {
    prevSlideMessage: 'Previous slide',
    nextSlideMessage: 'Next slide',
    firstSlideMessage: 'First slide',
    lastSlideMessage: 'Last slide'
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  on: {
    init: function () {

      if (this.el.hasAttribute('data-swiper-autoplay')) {
        // Set autoplay if data attribute has numeric value
        const delay = parseInt(this.el.getAttribute('data-swiper-autoplay'));
        if (delay) {
          this.params.autoplay.delay = delay;
          this.autoplay.start();
        }
      }
    },
    tap: function () {
      // Stop autoplay (if enabled) on tap
      this.autoplay.stop();
    }
  }
}


function initializeSwiper(wrapperSelector, additionalOptions) {

  const options = {...defaultSwiperOptions, ...additionalOptions }
  const wrapperElements = document.querySelectorAll(wrapperSelector)
  wrapperElements.forEach((wrapperElement) => {
    return new Swiper(wrapperElement, options)
  })
}


export function initializeSwiperInstances() {

  // Banner
  initializeSwiper('.swiper-container.swiper-banner', {})


  initializeSwiper('.swiper-container.swiper-cards', {
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 4
      }
    }
  })


  // Cards large
  initializeSwiper('.swiper-container.swiper-cards-large', {
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      1024: {
        slidesPerView: 3
      }
    }
  })

  // Bubbles
  initializeSwiper('.swiper-container.swiper-bubbles', {
    breakpoints: {
      480: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 5
      }
    }
  })

  // Bubbles Large
  initializeSwiper('.swiper-container.swiper-bubbles-lg', {
    breakpoints: {
      480: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 4
      },
      1400: {
        slidesPerView: 5
      }
    }
  })

  // Bubbles Half Width
  initializeSwiper('.swiper-container.swiper-bubbles-half-width', {
    breakpoints: {
      480: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      1024: {
        slidesPerView: 2
      },
      1400: {
        slidesPerView: 3
      }
    }
  })

  //FAQs
  initializeSwiper('.swiper-container.swiper-faqs', {
    breakpoints: {
      1024: {
        slidesPerView: 3
      }
    }
  })

  //Repo Autos
  initializeSwiper('.swiper-container.slider-auto-repo', {
    breakpoints: {
      1024: {
        slidesPerView: 5
      }
    }
  })

  
}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeSwiperInstances();
})
